import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-van-transfer',
  templateUrl: './van-transfer.component.html',
  styleUrls: ['./van-transfer.component.css']
})
export class VanTransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
